import ReactModal from "@public/ui-toolkit/src/ReactModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Button, Input, InputDropdown } from "@public/ui-toolkit";
import './style.css';
import moment from "moment";
import { alertService } from "@hedgefund/shared/src/Alert";
import { Row, Col, Tooltip } from "antd";
import { CanCan, Permissions, getNumberWithUnit } from "@hedgefund/shared";
import VerticalButton from "@public/ui-toolkit/src/VerticalButton";
import { useRef } from "react";

const FCNProfileHeader = ({ myProfileState, stratagies, onSubmitNewPostHandler,
  updateInfo, updateTenantLogoImage, companyLogoUrl, getAllStrategy,
  onClickFollowAllocatorHandler, followAllocators, portal = "allocator" }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const [companyLogo, setCompanyLogo] = useState();
  const [openLogo, setOpenLogo] = useState(false);
  const [LogoUrl, setLogoUrl] = useState();


  const onOpenModal = () => {
    dispatch(getAllStrategy());
    setOpen(true);
  }
  const onCloseModal = () => setOpen(false);
  const messageRef = useRef("");
  const subjectRef = useRef("");

  const formikContact = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
    validationSchema: Yup.object({
      subject: Yup.string().required("Subject is Required."),
      message: Yup.string().required("Message is Required"),
    }),
    onSubmit: (values) => {
      onSubmitNewPostHandler(values);
      setOpenContact(false);
      formikContact.resetForm();

    },
  });

  useEffect(() => {

    setCompanyLogo(myProfileState?.logo ? myProfileState?.logo : "./assets/images/empty-avatar.png")
  }, [myProfileState]);

  const formik = useFormik({

    initialValues: {
      address: myProfileState ? myProfileState?.address : "",
      companyInfo: myProfileState ? myProfileState?.companyInfo : "",
      foundedDate: myProfileState ? moment(myProfileState?.foundedDate).format("YYYY-MM-DD") : "",
      idpi: myProfileState ? myProfileState?.idpi : "",
      netDollar: myProfileState ? myProfileState?.netDollar : "",
      aum: myProfileState ? myProfileState?.aum : "",
      strategyId: myProfileState?.strategyId ? myProfileState?.strategyId : "",
      investorTypeId: myProfileState?.investorTypeId ? myProfileState?.investorTypeId : ""
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      if (portal === "allocator") {
        values.strategyId = null;
        values.investorTypeId = Number(values.investorTypeId)
      } else {
        values.strategyId = Number(values.strategyId)
        values.investorTypeId = null
      }
      updateInfo(values, onSuccessAlert);
      onCloseModal();
      formik.resetForm();
    },
  });

  const onSuccess = () => {
    alertService.success("Comany Image Update Successfully!", { autoClose: true });
  };
  const onSuccessAlert = () => {
    alertService.success("Tenant Update Successfully!", { autoClose: true });
  };

  const UpdateTenantLogoImage = () => {
    const formData = new FormData();
    formData.append("logo", LogoUrl);
    updateTenantLogoImage(formData, onSuccess, () => setOpenLogo(false));
    setLogoUrl(companyLogo);
  }
  const handleLogoImageChange = (e) => {
    var reader = new FileReader();
    reader.onload = function () {
      var output = document.getElementById("logo_image");
      output.src = reader.result;
      setCompanyLogo(reader.result);
    };
    setLogoUrl(e.target.files[0]);
    reader.readAsDataURL(e.target.files[0]);
  };
  return (
    <div className="position-fixed" style={{ width: "28%" }} >
      <Row>
        <Col span={24}>
          <button type="button" className="btn btn-secondary btn-editCover-Image" onClick={() => {
            setCompanyLogo(myProfileState?.logo ? myProfileState?.logo : "./assets/images/empty-avatar.png")
            setOpenLogo(true);
          }}>
            <Tooltip title="Edit Company Logo" showArrow={false}>
            <i className=" fa fa-pencil"></i>
            </Tooltip>
          </button>

          <img
            id="cover_image"
            className="logo-style"
            src={
              companyLogoUrl ? companyLogoUrl :
                myProfileState?.logo ?
                  myProfileState?.logo :
                  "/assets/images/bg1.png"
            }
            alt="Company Logo"
          />
        </Col>
        <Col span={24}>
          <Row>
            <Col span={24} className="text-center mt-3">
              <div className="Fund-FontSize" style={{ fontSize : "26px" }}>{myProfileState?.name}</div>
              <h4>{myProfileState?.address}</h4>
            </Col>
            <Col span={23} offset={1} className="text-center mt-3">
              <VerticalButton
                btnName={"Edit"}
                iconClass="fa fa-edit mr-1"
                btnType="primary"
                onClick={onOpenModal}
              />
              <VerticalButton
                btnName={"Team"}
                iconClass="fa fa-users mr-1"
                btnType="primary"
                onClick={() => history.push("/management")}
              />
              <CanCan permissionName={Permissions?.CONTACT_US_PAGE?.name}>
                <VerticalButton
                  btnName={"Contact FCN"}
                  iconClass="fa fa-comments mr-1"
                  btnType="primary"
                  onClick={() => setOpenContact(true)
                  }
                />
              </CanCan>
            </Col>
          </Row>
          <Row className="text-center mt-3">
            <Col span={8}>
              <div className="Fund-FontSize">{`${myProfileState?.aum !== null ? getNumberWithUnit(myProfileState?.aum) : "N/A"}`}</div>
              <h4>AUM</h4>
            </Col>
            <Col span={8} style={{ borderLeft: "2px solid #c1c1c1", borderRight: "2px solid #c1c1c1" }}>
              <div className="Fund-FontSize">{portal === "allocator" ? myProfileState?.investorTypeName : myProfileState.strategyName ? myProfileState.strategyName : "N/A"}</div>
              <h4> {portal === "allocator" ? "Investor Type" : "Strategy"}</h4>
            </Col>
            <Col span={8}>
              <div className="Fund-FontSize">{myProfileState.foundedDate ? moment(myProfileState?.foundedDate, "YYYY-MM-DD").format("LL") : "N/A"}</div>
              <h4>Founded Date</h4>
            </Col>
          </Row>
        </Col>
        {/* <hr style={{ marginRight: "5px" }} /> */}
        <Col span={24}>
          <Row className="ml-4 mt-3">

            <Col span={9} offset={1}>
              <div class="ml-2 Fund-FontSize">
                <i className="fa fa-phone mr-2"></i>
                {myProfileState?.phoneNumber ? myProfileState?.phoneNumber : "N/A"}
              </div>
            </Col>
            <Col span={14}>
              <div class="ml-2 Fund-FontSize" >
                <i className="fa fa-globe mr-2"></i>
                {myProfileState?.websiteUrl ? myProfileState?.websiteUrl : "N/A"}
              </div>
            </Col>
            <Col span={24}>
              <div className="ml-2 mt-4">
                <b className="Fund-FontSize">Overview</b> :
                <div className="ml-2" style={{ width: "90%" }}>{myProfileState?.companyInfo ? myProfileState?.companyInfo : "N/A"}</div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <ReactModal open={openLogo} onClose={() => setOpenLogo(false)} center title={"Update Company Logo"} >
        <div className="modal-body pt-0">
          <label>Company Logo</label>
          <div className="edit-user-picture">
            <img
              id="logo_image"
              src={
                companyLogo
                  ? companyLogo
                  : "./assets/images/empty-avatar.png"
              }
              className="cover_Image"
              alt="Company Logo"
            />
            <div className="edit-btn" style={{ marginTop: "20px" }}>
              <Input
                type="file"
                onChange={handleLogoImageChange}
                name="logoImage"
                accept="image/*"
                props
              />
            </div>
          </div>
          <div style={{ marginTop: "20px" }} className="justify-content-center align-items-center d-flex">
            <Button
              btnName="Update"
              btnType="primary"
              type="submit"
              onClick={UpdateTenantLogoImage}
            />
          </div>
        </div>
      </ReactModal>
      <ReactModal open={open} onClose={onCloseModal} center title={"Edit Company Info"} >
        <form onSubmit={formik.handleSubmit}>
          <div className="modal-body pt-0">
            { }
            <div className="row">
              <div className="mt-5">
                <Input
                  type="text"
                  placeholder="Address"
                  id="address"
                  label="Address"
                  forr="address"
                  props
                  {...formik.getFieldProps("address")}
                />
              </div>
              <div className="mt-5 col-lg-6">
                <Input
                  type="text"
                  placeholder="Company Info"
                  id="companyInfo"
                  label="Company Info"
                  forr="companyInfo"
                  props
                  {...formik.getFieldProps("companyInfo")}
                />
              </div>
              <div className="mt-5 col-lg-6">
                {(() => {
                  if (portal === "allocator") {
                    return (
                      <InputDropdown
                        id="investorTypeId"
                        placeholder="Inverstor Type"
                        value={myProfileState?.investorTypeId}
                        label="Investor Type"
                        inputDropdownOptions={stratagies}
                        defaultOptionName="Investor Type"
                        optionKey={"name"}
                        {...formik.getFieldProps("investorTypeId")}
                      />)
                  } else {
                    return (
                      <InputDropdown
                        id="strategyId"
                        placeholder={"Strategy"}
                        value={myProfileState?.strategyId}
                        label="Strategy"
                        inputDropdownOptions={stratagies}
                        defaultOptionName="Strategy"
                        optionKey={"name"}
                        {...formik.getFieldProps("strategyId")}
                      />)
                  }
                })()}
              </div>
              <div className="mt-5 col-lg-6">
                <Input
                  type="date"
                  placeholder="Founded Date"
                  id="foundedDate"
                  label="Founded Date"
                  forr="foundedDate"
                  name="foundedDate"
                  value={
                    moment.min(moment(myProfileState?.foundedDate)) || moment.max(moment(myProfileState?.foundedDate))
                      ? null : myProfileState?.foundedDate
                  }
                  max={moment().format("mm/dd/yyyy")}
                  props
                  {...formik.getFieldProps("foundedDate")}
                />
              </div>
              <div className="mt-5 col-lg-6">
                <Input
                  type="text"
                  placeholder="IDPI"
                  id="idpi"
                  label="IDPI"
                  forr="idpi"
                  props
                  {...formik.getFieldProps("idpi")}
                />
              </div>
              <div className="mt-5 col-lg-6">
                <Input
                  type="text"
                  placeholder="Net Dollar"
                  id="netDollar"
                  label="Net Dollar"
                  forr="netDollar"
                  props
                  {...formik.getFieldProps("netDollar")}
                />
              </div>
              <div className="mt-5 col-lg-6">
                <Input
                  type="text"
                  placeholder="AUM"
                  id="aum"
                  label="AUM"
                  forr="aum"
                  props
                  {...formik.getFieldProps("aum")}
                />
              </div>
            </div>
          </div>
          <div className="justify-content-center align-items-center d-flex">
            <Button
              btnName="Save"
              btnType="primary"
              type="submit"
              dataDismiss="modal"
            />
          </div>
        </form>
      </ReactModal>
      <ReactModal open={openContact} onClose={() => setOpenContact(false)} center title={"FCN Admin Contact"}>
        <div className="p-xxl-5 p-md-4 p-3 box-shadow bg-white rounded-large">
          <div className="text-center box-lg">
            <h4 className="stylish-title text-blue mb-5">
              Contact FCN Admin
            </h4>
            <form onSubmit={formikContact.handleSubmit}>
              <div className="row g-4">
                <div className="col-12">
                  <div className="form-floating">
                    <Input
                      type="text"
                      placeholder="Subject"
                      id="subject"
                      label="Subject"
                      inputRef={subjectRef}
                      {...formikContact.getFieldProps("subject")}
                      props
                    />
                    {formikContact.touched.subject && formikContact.errors.subject ? (
                      <div className="form-error-message  pt-4">
                        {formikContact.errors.subject}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      id="message"
                      placeholder="Message"
                      rows="6"
                      onChange={(e) => e.target.value}
                      {...formikContact.getFieldProps("message")}
                      ref={messageRef}
                    ></textarea>
                    <label for="description">Message</label>
                    {formikContact.touched.message && formikContact.errors.message ? (
                      <div className="form-error-message pt-4">
                        {formikContact.errors.message}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <Button
                  btnName="Submit"
                  btnType="primary"
                  type="submit"
                />
              </div>
            </form>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export default FCNProfileHeader;
